<ion-header>
  <ion-toolbar style="--background: linear-gradient(135deg, #4f46e5, #7c3aed); --color: white;">
    <ion-title style="font-size: 18px; font-weight: 600;">Components</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" style="--color: white;">
        <ion-icon slot="icon-only" name="cube"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>✨ Ionic Components</ion-card-title>
    </ion-card-header>
    
    <ion-card-content>
      <p>Explore the available Ionic components for building your app:</p>
    </ion-card-content>
  </ion-card>

  <div *ngFor="let component of components" style="margin-bottom: 16px;">
    <ion-card>
      <ion-card-header>
        <ion-card-title style="display: flex; align-items: center; gap: 8px;">
          <ion-icon [name]="component.icon" color="primary"></ion-icon>
          {{ component.name }}
        </ion-card-title>
      </ion-card-header>
      
      <ion-card-content>
        <p>{{ component.description }}</p>
        
        <div *ngIf="component.name === 'Buttons'" style="margin-top: 16px;">
          <ion-button>Default</ion-button>
          <ion-button color="primary">Primary</ion-button>
          <ion-button color="secondary">Secondary</ion-button>
          <ion-button color="tertiary">Tertiary</ion-button>
          <ion-button color="success">Success</ion-button>
          <ion-button color="warning">Warning</ion-button>
          <ion-button color="danger">Danger</ion-button>
          <ion-button fill="outline">Outline</ion-button>
          <ion-button fill="clear">Clear</ion-button>
        </div>
        
        <div *ngIf="component.name === 'Cards'" style="margin-top: 16px;">
          <ion-card>
            <ion-card-header>
              <ion-card-title>Card Example</ion-card-title>
              <ion-card-subtitle>Card Subtitle</ion-card-subtitle>
            </ion-card-header>
            
            <ion-card-content>
              This is an example of an Ionic card component with header and content.
            </ion-card-content>
          </ion-card>
        </div>
        
        <div *ngIf="component.name === 'Lists'" style="margin-top: 16px;">
          <ion-list>
            <ion-item>
              <ion-label>Item 1</ion-label>
            </ion-item>
            <ion-item>
              <ion-label>Item 2</ion-label>
            </ion-item>
            <ion-item>
              <ion-label>Item 3</ion-label>
            </ion-item>
          </ion-list>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>